import { SVGProps } from 'react';

const Rat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 22H4a2 2 0 1 1 0-4h12m-2.764 0a3 3 0 0 0-2.2-5M16 9h.01m.81-5.06a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a2.998 2.998 0 0 0-3.5 3m3-11.054a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18"
    />
  </svg>
);
export default Rat;
